import React from "react";
import {Waypoint} from "./WaypointComponent";

interface WaypointDetailedProps {
    waypoint: Waypoint
}

const WaypointDetailed = (props: WaypointDetailedProps) => {

    const waypoint = props.waypoint ?? {};

    return (
        <address>
            <strong>{waypoint.companyName}</strong><br/>
            {waypoint.address.street}<br/>
            {waypoint.address.suburb}<br/>
            {waypoint.contactName}<br/>
            {waypoint.contactTelephone && <span><abbr title="Phone">P:</abbr>{waypoint.contactTelephone}</span>}
        </address>
    )

}

export default WaypointDetailed;
